<template>
  <div class="emoji-square-container p-8">
    <!-- Title controlled by Tenant Regions Wrapper (App.vue) -->

    <!-- Verification Warning -->
    <div v-if="!wizardStore.isHumanVerified" class="text-center mb-6">
        <span class="inline-block bg-orange-100 text-orange-600 px-4 py-1 rounded-full text-sm font-medium">
            🔒 Verify humanity to unlock
        </span>
    </div>

    <!-- Grid -->
    <div class="emoji-grid grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto relative">
        
        <!-- Locked State Overlay -->
        <div v-if="!wizardStore.isHumanVerified" class="absolute inset-0 z-20 backdrop-blur-sm bg-white/50 rounded-2xl flex items-center justify-center cursor-not-allowed">
            <div class="text-center">
                 <div class="text-4xl grayscale opacity-50 mb-2">🤖</div>
                 <p class="font-bold text-gray-400">Locked</p>
            </div>
        </div>

        <div 
            v-for="item in items" 
            :key="item.id"
            @click="selectItem(item)"
            class="emoji-card group bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer p-6 flex flex-col items-center justify-center border-2"
            :class="[
                String(selectedId) === String(item.id) ? 'border-lds-primary scale-105 ring-2 ring-lds-primary/20' : 'border-transparent hover:border-gray-100 hover:scale-105',
                !wizardStore.isHumanVerified ? 'pointer-events-none opacity-50' : ''
            ]"
        >
            <!-- Icon Container (White Background Rule) -->
            <div class="icon-wrapper w-24 h-24 bg-white rounded-full flex items-center justify-center text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                {{ item.emoji || '❓' }}
            </div>
            
            <!-- Label -->
            <span class="font-lds-body font-medium text-gray-700 group-hover:text-lds-primary transition-colors">
                {{ item.label || item.name }}
            </span>
        </div>
    </div>
  </div>
</template>

<script>
import { computed, watch } from 'vue';
import { useWizardStore } from '@emoji-photo/wizard-island'; 
import { useTenantStore } from '../../store/tenantStore';

export default {
  name: 'EmojiSquare',
  props: {
      title: { type: String, default: 'Choose Your Companion' },
      subtitle: { type: String, default: 'Select the spirit that calls to you' }
  },
  setup() {
    const wizardStore = useWizardStore();
    const tenantStore = useTenantStore();

    const items = computed(() => {
        const storeItems = tenantStore.config?.emojis || tenantStore.config?.animals;
        if (storeItems && storeItems.length > 0) return storeItems;

        // Dev Mock
        console.error('[SSOT-VIOLATION] Tenant config missing. Falling back to Dev Mock. Fix your database seeding!');
        return [
            { id: 'dog', emoji: '🐶', label: 'Dog' },
            { id: 'cat', emoji: '🐱', label: 'Cat' },
            { id: 'fox', emoji: '🦊', label: 'Fox' },
            { id: 'panda', emoji: '🐼', label: 'Panda' },
            { id: 'lion', emoji: '🦁', label: 'Lion' },
            { id: 'tiger', emoji: '🐯', label: 'Tiger' },
            { id: 'koala', emoji: '🐨', label: 'Koala' },
            { id: 'bird', emoji: '🐦', label: 'Bird' },
        ];
    });

    const selectedId = computed(() => wizardStore.activeEmojiId);

    const selectItem = (item) => {
        wizardStore.setEmoji(item);
        wizardStore.unlockStep(4);
        
        setTimeout(() => {
            const nextStep = document.querySelector('[data-island-id="PreviewIsland"]');
            if (nextStep) nextStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500); 
    };

    watch([() => wizardStore.isHumanVerified, () => items.value.length], ([isHuman, itemsCount]) => {
        if (isHuman && !wizardStore.activeEmojiId && itemsCount > 0) {
            console.log('[EmojiIsland] Human Verified & Items Loaded! Triggering Random Wow...');
            wizardStore.randomizeSelection(items.value);
            setTimeout(() => {
                 const nextStep = document.querySelector('[data-island-id="PreviewIsland"]');
                 if (nextStep) nextStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 1000);
        }
    });

    return { wizardStore, items, selectedId, selectItem };
  }
}
</script>

<style scoped>
/* Scoped overrides if needed, mostly using Tailwind lds-* tokens */
</style>
